// cookie-bar.ts (refactored)
import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { CookieConsent } from '../../services/cookie-consent.service';

@Component({
  selector: 'app-cookie-bar',
  templateUrl: './cookie-bar.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cookie-bar.scss',
})
export class CookieBar {
  @Output() openCookieSettings = new EventEmitter<void>();
  @Output() onCookiesAction = new EventEmitter<CookieConsent>();

  accept(): void {
    this.onCookiesAction.emit({
      necessaryConsent: true,
      analyticsConsent: true,
    });
  }

  reject(): void {
    this.onCookiesAction.emit({
      necessaryConsent: true,
      analyticsConsent: false,
    });
  }
}
